var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverwareBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFF9C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12.5,
    stroke: "#18181B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#silverware-badge_svg__clip0_115_3646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.667 12v5.333h2v5.334H22V9.333c-1.84 0-3.333 1.494-3.333 2.667zm-3.334 2H14V9.333h-1.333V14h-1.334V9.333H10V14a2.666 2.666 0 002.667 2.667v6H14v-6A2.666 2.666 0 0016.667 14V9.333h-1.334V14z",
    fill: "#27272A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "silverware-badge_svg__clip0_115_3646"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 8)",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgSilverwareBadge;